import React, { useEffect, useState } from 'react';
import styles from './breadcrumbs.module.scss';
import { useLocation } from 'react-router';
import { GLOBAL_CONFIG } from 'config/config';
import { Page } from 'config/types';
import { Breadcrumb } from 'shared/types';
import { RightOutlined } from '@ant-design/icons/lib';
import { classNames } from 'shared/utils';
import { NavLink } from 'react-router-dom';

export const AppBreadcrumbs = () => {
  const location = useLocation();
  const [breadcrumbs, setBreadcrumbs] = useState<Breadcrumb[]>([]);
  const mainBreadCrumb: Breadcrumb = { name: 'Главная', link: '/' };
  
  useEffect(() => {
	const pathnameParts = location.pathname.split('/').filter(Boolean);
	const targetPage = GLOBAL_CONFIG.pages.find(
	  (page: Page) => (page.type === pathnameParts[0] && page.id === Number(pathnameParts[1]))
	);
	const breadCrumbs: Breadcrumb[] = targetPage
	  ? [{ name: targetPage.title, link: `${targetPage.type}/${targetPage.id}`}]
	  : [];
	
	if (targetPage?.parentId) {
	  let currentItem = targetPage;
	  
	  while (currentItem.parentId) {
	    let parentItem = GLOBAL_CONFIG.pages.find(
		  (page: Page) => page.type === pathnameParts[0] && page.id === currentItem.parentId
		) as Page;

	    breadCrumbs.unshift({ name: parentItem.title, link: `${parentItem.type}/${parentItem.id}`});
	    
	    currentItem = parentItem as Page;
	  }
	}
	
	breadCrumbs.unshift(mainBreadCrumb);
	
	setBreadcrumbs(breadCrumbs);
  }, [location.pathname]);
  
  return (
	<div className={styles.breadcrumbs}>
	  {breadcrumbs.map((item, idx) => (
	    <div className={styles.breadcrumbWrapper} key={idx}>
		  <div
			className={classNames(styles.breadcrumb, breadcrumbs.length > 3 && styles.optimizedBreadcrumb)}
			title={breadcrumbs.length > 3 ? item.name : ''}
		  >
			<NavLink to={item.link}>{item.name}</NavLink>
		  </div>
		  { idx < breadcrumbs.length - 1
		  	&& <RightOutlined style={{ fontSize: '14px', color: '#737781', margin: '0 8px' }}/>
		  }
		</div>
	  ))}
	</div>
  );
};
